import { render, staticRenderFns } from "./winnerByArea.vue?vue&type=template&id=8af528b2&scoped=true&"
import script from "./winnerByArea.vue?vue&type=script&lang=js&"
export * from "./winnerByArea.vue?vue&type=script&lang=js&"
import style0 from "./winnerByArea.vue?vue&type=style&index=0&id=8af528b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af528b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardSubtitle,VCardText,VDivider})
